import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme } from '@mui/material';

export const MuiListItem: {
    defaultProps?: ComponentsProps['MuiListItem'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiListItem'];
    variants?: ComponentsVariants['MuiListItem'];
} = {
    styleOverrides: {
        root: () => [
            {
                minInlineSize: '160px',
                textAlign: 'start',
            },
        ],
    },
};

export const MuiListItemIcon: {
    defaultProps?: ComponentsProps['MuiListItemIcon'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiListItemIcon'];
    variants?: ComponentsVariants['MuiListItemIcon'];
} = {
    styleOverrides: {
        root: (props) => [
            {
                minInlineSize: 0,
                marginInlineEnd: props.theme.spacing(props.theme.tokens.spacing.xs),
            },
        ],
    },
};

export const MuiListItemText: {
    defaultProps?: ComponentsProps['MuiListItemText'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiListItemText'];
    variants?: ComponentsVariants['MuiListItemText'];
} = {
    styleOverrides: {
        inset: (props) => [
            {
                paddingInlineStart: props.theme.spacing(props.theme.tokens.spacing.xl),
            },
        ],
    },
};

export const MuiListItemButton: {
    defaultProps?: ComponentsProps['MuiListItemButton'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiListItemButton'];
    variants?: ComponentsVariants['MuiListItemButton'];
} = {
    styleOverrides: {
        root: () => [
            {
                textAlign: 'start',
            },
        ],
    },
};
